import { render, staticRenderFns } from "./DashboardMainTabs.vue?vue&type=template&id=27e32417"
import script from "./DashboardMainTabs.vue?vue&type=script&lang=js"
export * from "./DashboardMainTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports